import * as React from 'react';
import { SVGProps } from '../../types';

export const IconShortAnswerSvg = ({ title, titleId, ...props }: SVGProps) => (
  <svg
    width={18}
    height={18}
    viewBox="0 0 18 18"
    focusable="false"
    fill="none"
    stroke="currentColor"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <line x1="14.75" y1="10.75" x2="4.25"  y2="10.75" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="14.75" y1="7.75"  x2="4.25"  y2="7.75"  strokeWidth="1.5" strokeLinecap="round" />
    <line x1="14.75" y1="4.75"  x2="10.25" y2="4.75" strokeWidth="1.5" strokeLinecap="round" />
    <line x1="8.75"  y1="13.75" x2="4.25"  y2="13.75" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
